module.exports = __webpack_public_path__ + "static/img/207_TO8_2126.e7416b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/207_TO8_2126.jpg
// module id = 1nOA
// module chunks = 0